import { dba } from "app/common/utilities/db"
import db, { Article, Prisma } from "db"

export const findFirstArticle = <T extends Prisma.ArticleFindFirstArgs>(
  args: Prisma.SelectSubset<T, Prisma.ArticleFindFirstArgs>
) => {
  return dba<Prisma.CheckSelect<T, Article, Prisma.ArticleGetPayload<T>>>(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    () => db.article.findFirst(args) as any
  )
}
